export default "__VITE_ASSET__CrwULi40__"